import { loadingOpacityMixin } from 'components/Loader/styled'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

const StyledInput = styled.input<{ error?: boolean; fontSize?: string; align?: string; disabled?: boolean }>`
  color: ${({ error, theme }) => (error ? theme.critical : theme.neutral1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  width: 0;
  position: relative;
  font-weight: 485;
  outline: none;
  border: none;
  flex: 1 1 auto;
  background-color: transparent;
  font-size: ${({ fontSize }) => fontSize ?? '28px'};
  text-align: ${({ align }) => align && align};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px;
  -webkit-appearance: textfield;
  text-align: right;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.neutral3};
  }
`



interface InputProps extends Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as'> {
  value: string | number
  onUserInput: (input: string) => void
  error?: boolean
  fontSize?: string
  align?: 'right' | 'left'
  maxDecimals?: number
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ value, onUserInput, placeholder, maxDecimals, ...rest }: InputProps, ref) => {
    
 


    return (
      <StyledInput
        {...rest}
        ref={ref}
        value={value.toString()}
        onChange={(event) => {
          
            // Remove any character that is not a digit or a comma
            onUserInput(event.target.value.replace(/[^0-9,]/g, ''))
          
        }}
        // universal input options
        inputMode="numeric"
        autoComplete="off"
        autoCorrect="off"
        // text-specific options
        type="text"
        pattern="^([1-9][0-9]?|100)$"
        placeholder={placeholder || '0'}
        minLength={1}
        maxLength={494} // max length for token ids: 4(max_token_digits)*99+99-1(virgules) = 494
        spellCheck="false"
      />
    )
  }
)

Input.displayName = 'Input'

const MemoizedInput = React.memo(Input)
export { MemoizedInput as Input }

export const WrapStyledNumericalInput = styled(MemoizedInput)<{ $loading: boolean, disabled?: boolean }>`
  ${loadingOpacityMixin};
  text-align: left;
  font-size: 22px;
  font-weight: 485;
  max-height: 44px;
  opacity: ${({ disabled }) => (!disabled ? 1 : 0.4)};
`
